module.exports = __webpack_public_path__ + "static/media/info-fill-18.93dc7d8d.svg";